import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, FolderCheck } from "lucide-react";
import api from "../../lib/api";
import { dueSentence, headline } from "../../lib/portalPortfolio";

/** On the portal's home, under a participant's group: the final portfolio,
 *  its deadline from the first day (procedure 29.611, art. 20 alin. 4), and
 *  where it stands. */
export default function PortfolioCard({ groupId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/portal/groups/${groupId}/portfolio`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [groupId]);
  if (!data || !data.session) return null;
  return (
    <Link to={`/portal/portofoliu/${groupId}`} data-testid="portal-portfolio-card"
      className="mt-4 flex items-center gap-3 rounded-xl border border-[#965EA7]/25 bg-[#965EA7]/[0.04] px-4 py-3 hover:border-[#965EA7]">
      <FolderCheck size={18} className="shrink-0 text-[#965EA7]" />
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-[#373A45]">Portofoliul final · se depune {dueSentence(data.session)}</span>
        <span className="block truncate text-xs text-[#6B7280]">{headline(data)}</span>
      </span>
      <ChevronRight size={16} className="shrink-0 text-[#9CA3AF]" />
    </Link>
  );
}
